<template>

<a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <a-divider dashed orientation="left">Informasi Pengumuman</a-divider>
                <a-form-item label="Judul">
                    <a-input
                        placeholder="Judul"
                        v-decorator="[
                            'title',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="Description">
                    <quill-editor
                        :content="content"
                        :options="editorOption"
                        @change="onEditorChange($event)"
                        v-decorator="[
                            'description',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]">
                    </quill-editor>
                </a-form-item>

                <a-form-model-item label="Status">
                    <a-switch
                        label="Status"
                        :label-col="{ span: layout.label }"
                        :wrapper-col="{ span: layout.wrapper }"
                        v-decorator="[
                            'is_active',
                            {
                                valuePropName: 'checked'
                            }
                        ]" />
                </a-form-model-item>

                <a-form-model-item label="Dashboard">
                    <a-switch
                        label="Dashboard"
                        :label-col="{ span: layout.label }"
                        :wrapper-col="{ span: layout.wrapper }"
                        v-decorator="[
                            'is_dashboard',
                            {
                                valuePropName: 'checked'
                            }
                        ]" />
                </a-form-model-item>

                <a-form-item label="Lampiran" v-if="!editing">
                    <a-upload
                        :file-list="fileList"
                        :remove="handleRemove"
                        :before-upload="beforeUpload"
                        @change="handleChange"
                    >
                        <a-button>
                            <a-icon type="upload" /> Select File
                        </a-button>
                    </a-upload>
                </a-form-item>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: { quillEditor },
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 2,
                    wrapper: 22
                };
            }
        },
        announcement: {
            type: String,
            default: ""
        }
    },
    created() {
        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    computed: {
        editing() {
            return this.announcement !== "";
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
            fileList: [],
            content: '',
            editorOption: {
                placeholder: 'Insert text here...',
            }
        };
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.announcement.show", {
                        announcement: this.announcement
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    formData['description'] = this.content

                    let promise;

                    if (this.editing) {
                        promise = this.$http.put(
                            this.routeUri("api.announcement.update", {
                                announcement: this.announcement
                            }),
                            formData
                        );
                    } else {
                        var data = new FormData();

                        if(formData.is_active == undefined){
                            formData.is_active = "0"
                        }else{
                            if(formData.is_active === true){
                                formData.is_active = "1"
                            }else{
                                formData.is_active = "0"
                            }
                        }

                        if(formData.is_dashboard == undefined){
                            formData.is_dashboard = "0"
                        }else{
                            if(formData.is_dashboard === true){
                                formData.is_dashboard = "1"
                            }else{
                                formData.is_dashboard = "0"
                            }
                        }

                        for (var k in formData) {
                            if (formData.hasOwnProperty(k)) {
                                data.append(k, formData[k]);
                            }
                        }

                        if(this.fileList.length > 0){
                            data.append("attachment", this.fileList[0]);
                        }

                        promise = this.$http.post(
                            this.routeUri("api.announcement.store"),
                            data
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));

                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.data = [];
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];
            return false;
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            if (fileList.length > 1) {
                fileList = fileList.slice(-1);

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url;
                    }
                    return file;
                });
                this.fileList = fileList;
            }
        },
        onEditorChange({ quill, html, text }) {
            this.content = html
      }
    },
    watch: {
        item: function(value) {
            this.form.getFieldDecorator("title", { initialValue: value.title });
            this.form.getFieldDecorator("description", { initialValue: value.description });
            this.content = value.description;
            this.form.getFieldDecorator("is_dashboard", {
                initialValue: value.is_dashboard
            });
            this.form.getFieldDecorator("is_active", {
                initialValue: value.is_active == true ? true : false
            });
        }
    }
}
</script>
